import { DashboardOverview } from '@/app/components/dashboard/DashboardOverview'

export default function DashboardPage() {
  return <DashboardOverview />
}
